import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TreeNode extends Component {
  static propTypes = {
    value: PropTypes.string,
  };
}
